import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccountCompanyService } from '../services/account-company.service';
import { AuthService } from '../services/auth.service';
import {
  ACCOUNTING_COMPANY_HTTP_HEADER,
  FRD_COMPANY_HTTP_HEADER,
} from '../constants/accounting-company.constants';

/** Login / refresh / logout — no company context header. */
const AUTH_ENDPOINT_PATTERN = /\/auth\/(?:login|refresh|logout)(?:\?|$)/i;

function isAuthEndpoint(url: string): boolean {
  return AUTH_ENDPOINT_PATTERN.test(url);
}

/**
 * Attaches FRD `X-Company-Id` (and legacy `X-Accounting-Company-Id`) on authenticated
 * requests once the user has completed company selection.
 */
export const accountingCompanyInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const companyService = inject(AccountCompanyService);

  const token = authService.getToken();
  if (!token || isAuthEndpoint(req.url)) {
    return next(req);
  }

  if (!companyService.isCompanyOpen()) {
    return next(req);
  }

  const companyId = companyService.getActiveCompanyId().trim();
  if (!companyId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        [FRD_COMPANY_HTTP_HEADER]: companyId,
        [ACCOUNTING_COMPANY_HTTP_HEADER]: companyId,
      },
    }),
  );
};
